export enum InjectionMoldingEntityStatus {
    Active = 'Active',
    Obsolete = 'Obsolete',
}
